import { combineReducers } from 'redux';

import {
    UPLOADED_DEBTS,
    SELECTED_PRODUCT,
    CHANGED_MAPPED_FIELDS,
    PROCESSED_SPREADSHEET,
    DEBTS_FILE_CHANGED,
    EDITED_PRODUCT_NAME,
    FINISHED_IMPORT,
    LOADED_ASSOCIATION_FIELDS,
    SET_SPREADSHEET_FILENAME,
    LIST_BANKS_RETRIEVED,
    LOADING_SPREADSHEET_ERRORS,
    LOADED_SPREADSHEET_ERRORS,
    CORRECTED_DEBT,
    CREATED_DEBT,
    DEBT_MANUALLY_DELETED,
    FINISHED_MANUAL_IMPORT,
} from 'src/modules/importer/actions/importer.action';
import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';

const selectedProduct = (state = null, action) => {
    switch (action.type) {
        case SELECTED_PRODUCT:
            return action.payload;
        case EDITED_PRODUCT_NAME:
            return { ...state, name: action.payload };
        case FINISHED_IMPORT:
            return null;
        default:
            return state;
    }
};

const debtsSpreadsheet = (state = null, action) => {
    switch (action.type) {
        case UPLOADED_DEBTS:
            return action.payload;
        case DEBTS_FILE_CHANGED:
        case FINISHED_IMPORT:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const manualDebts = (state = [], action) => {
    switch (action.type) {
        case CREATED_DEBT:
            return [...state, action.payload];
        case DEBT_MANUALLY_DELETED:
            return state.filter(obj => obj.debt.pk_debt !== action.payload);
        case FINISHED_IMPORT:
        case AUTH_LOGOUT:
            return [];
        default:
            return state;
    }
};

const spreadsheetFilename = (state = '', action) => {
    switch (action.type) {
        case SET_SPREADSHEET_FILENAME:
            return action.payload;
        case FINISHED_IMPORT:
        case AUTH_LOGOUT:
            return '';
        default:
            return state;
    }
};

const mappedFields = (state = [], action) => {
    switch (action.type) {
        case CHANGED_MAPPED_FIELDS:
            return action.payload;
        case DEBTS_FILE_CHANGED:
        case PROCESSED_SPREADSHEET:
        case FINISHED_IMPORT:
        case AUTH_LOGOUT:
            return [];
        default:
            return state;
    }
};

const importResult = (state = null, action) => {
    switch (action.type) {
        case PROCESSED_SPREADSHEET:
            return action.payload;
        case CORRECTED_DEBT:
            return {
                success: {
                    ...state.success,
                    debts: state.success.debts + 1,
                    debtors: state.success.debtors + 1,
                    amount: action.payload.success.installments
                        .reduce((prev, installment) => prev += parseInt(installment.amount, 10), state.success.amount),
                },
                failed: {
                    ...state.failed,
                    count: state.failed.count - 1,
                },
            };
        case FINISHED_MANUAL_IMPORT:
            return {
                success: {
                    debts: action.payload.length,
                    debtors: action.payload.length,
                    amount:
                        action.payload
                            .map(debt => debt.installments.reduce(
                                (res, installment) => (res += parseInt(
                                    installment.amount,
                                    10,
                                )),
                                0,
                            ))
                            .reduce((res, value) => (res += value), 0),
                },
                failed: {
                    count: 0,
                    failed: [],
                },
            };
        case FINISHED_IMPORT:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const associationFields = (state = [], action) => {
    switch (action.type) {
        case LOADED_ASSOCIATION_FIELDS:
            return action.payload;
        case AUTH_LOGOUT:
            return [];
        default:
            return state;
    }
};

const banksList = (state = [], action) => {
    switch (action.type) {
        case LIST_BANKS_RETRIEVED:
            return action.payload;
        case AUTH_LOGOUT:
            return [];
        default:
            return state;
    }
};

const loadingSpreadsheetErrors = (state = false, action) => {
    switch (action.type) {
        case LOADING_SPREADSHEET_ERRORS:
            return true;
        case LOADED_SPREADSHEET_ERRORS:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const spreadsheetErrors = (state = null, action) => {
    switch (action.type) {
        case LOADED_SPREADSHEET_ERRORS:
            return action.payload;
        case CORRECTED_DEBT:
            return {
                ...state,
                items: state.items.filter(
                    obj => obj.pk_import_errors
                        !== action.payload.success.pk_importerror,
                ),
            };
        case FINISHED_IMPORT:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    selectedProduct,
    debtsSpreadsheet,
    mappedFields,
    importResult,
    associationFields,
    spreadsheetFilename,
    banksList,
    loadingSpreadsheetErrors,
    spreadsheetErrors,
    manualDebts,
});
